// extracted by mini-css-extract-plugin
export default {"LongLabel":"PlatformDetail_LongLabel__NWfyP"};